import React from 'react';
import {Card, Col, Row, Statistic} from 'antd';

// Linha de tiles de KPI (Card + Statistic), mesmo padrão do resumo do AdminDashboard.
export default function KpiStatRow({items, loading}) {
    const colSpan = items.length >= 4 ? 6 : Math.max(24 / items.length, 6);

    return (
        <Row gutter={[16, 16]}>
            {items.map((item) => (
                <Col key={item.title} xs={24} sm={12} lg={colSpan}>
                    <Card loading={loading} size="small">
                        <Statistic
                            title={item.title}
                            value={item.value}
                            precision={item.precision}
                            prefix={item.prefix}
                            suffix={item.suffix}
                            formatter={item.formatter}
                            valueStyle={item.valueStyle}
                        />
                    </Card>
                </Col>
            ))}
        </Row>
    );
}
